import React, { createContext, useContext, useMemo, useState } from "react";

const LayoutContext = createContext(null);

export function LayoutProvider({ children }) {
  const [isOpen, setIsOpen] = useState(window.innerWidth >= 768);

  const value = useMemo(
    () => ({
      isOpen,
      setIsOpen,
      toggleSidebar: () => setIsOpen((current) => !current)
    }),
    [isOpen]
  );

  return <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>;
}

export function useLayout() {
  const context = useContext(LayoutContext);
  if (!context) {
    throw new Error("useLayout must be used inside LayoutProvider");
  }
  return context;
}
